import logo from "../../images/logo.png";
import "./LeadSqrLogo.scss";

const LeadSqrLogo = () => {
  return (
    <div className="leadSqrLogo">
      <img src={logo} alt="leadsqr logo" />
      <h3>lendsqr</h3>
    </div>
  );
};

export default LeadSqrLogo;
